import { Injectable } from '@angular/core';
import {Http, ResponseContentType} from '@angular/http';
import { environment } from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';
// import { Errorhandlers } from './errorhandlers';
import {EnvLoadService} from '../../../../env-load/env-load.service';
import {ActivatedRoute} from '@angular/router';

@Injectable()
export class UserServices {
    private apiUrl = `${environment.apiUrl}/api/v1`;
    private companyId = global['loginUser'].curCmpnId;
    private notiUrl = `${this.envLoadService.notiUrl}/wx/v1`;
    // private isUsers = false;

    constructor(private http: Http,
                private envLoadService: EnvLoadService) {
        this.companyId = global['loginUser'].curCmpnId;
        // this.isUsers = activeRoute['_routerState'].snapshot.url.indexOf('/user') !== -1 ? true : false;
        // console.log(this.isUsers);
    };

    /**
     * users
     * 사용자 목록 조회
     * Mothod : Get
     * API No : 17.1
     * /api/v1/{cmpnNo}/users?searchWord={searchWord}&page={page}&rows={rows}&oidx={oidx}
     **/
    getUserList(queryString?) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/users${queryParam}`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    getRoleUserList(queryString?) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/user/role/users${queryParam}`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    getUserRoleList() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/user/role`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    modifyUserRole(putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/users/role`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * users
     * Invite new user
     * Method : Post
     * TODO: Update API_URL with actual endpoint when provided
     * /api/v1/{cmpnNo}/users/invite
     **/
    inviteUser(postData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/user-invites`;
        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }


    getPendingUserList(queryString?) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/user-invites${queryParam}`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    deleteUser(userNo: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/users/${userNo}`;
        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * users - Basic information
     * Language 설정
     * Mothod : Put
     * API No : 17.6
     * /api/v1/{cmpnNo}/users/{userNo}/language/{langCd}
     **/
    // common.services.ts 에서 공통으로 사용.
    // updateUserLanguage(userNo, langCd) {
    //     const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/users/${userNo}/language/${langCd}`;
    //     return this.http
    //         .put(url, '')
    //         .toPromise()
    //         .then(res => res)
    //         .catch(this.handleError);
    // }

    private handleError(error: any) {
        //console.error('An error occurred', error);
        return Promise.resolve(error.message || error);
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/services/src/api/user.services.ts